export const STANDARD_USER = '/standard_user';
export const SUPER_ADMIN = '/global_admin';